import Modal from "react-responsive-modal";
import { TriangleAlert } from "lucide-react";

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
};

/**
 * Surfaces the backend ScheduleLockPolicy 422 (or the local pre-check)
 * when the user tries to lock a slot that already has a scheduled visit.
 */
export default function ModalScheduleLockBlocked({
  open,
  message,
  onClose,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      classNames={{
        modal: "remove-photo-modal",
      }}
    >
      <div className="mx-auto flex w-[90%] max-w-md flex-col items-center bg-white px-2 py-4 text-center sm:w-[70%]">
        <TriangleAlert className="h-10 w-10 text-amber-600" aria-hidden />
        <p className="mt-6 text-lg font-bold text-slate-800 sm:text-xl">
          Não é possível bloquear este horário
        </p>
        <p className="mt-3 text-sm font-normal leading-relaxed text-slate-600 sm:text-base">
          {message}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-8 w-full max-w-[220px] rounded-md bg-slate-800 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-900"
        >
          Entendi
        </button>
      </div>
    </Modal>
  );
}
